import { render, staticRenderFns } from "./md-breadcrumb.vue?vue&type=template&id=4b2e8e92"
import script from "./md-breadcrumb.vue?vue&type=script&lang=js"
export * from "./md-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./md-breadcrumb.vue?vue&type=style&index=0&id=4b2e8e92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports